<style scoped>
.img-container {
  padding-top: 75%;
  position: relative;
}

.img-container .img {
  background-color: #f7f7f7;
  position: absolute;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  width: 100%;
  height: 100%;
  background-repeat: no-repeat;
  background-position: center;
  background-size: contain;
}

a.disabled .img-container .img:before {
  content: 'not available';
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  background-color: #00000082;
  color: #fff7f7;
  font-size: 1.2em;
  text-transform: uppercase;
  text-align: center;
  left: 10px;
  right: 10px;
}
</style>
<template lang='pug'>
  .col.s6.m4
    router-link(:to='link', :class='{disabled: disabled}')
      div.img-container
        div.img(:style='{backgroundImage: "url(" + image + ")"}')
    p.title.light {{ title }}
    p.subtitle.micro {{subtitle}}
    .vspace.large
</template>
<script>
export default {
  props: ['title', 'subtitle', 'image', 'link', 'disabled']
}
</script>


// WEBPACK FOOTER //
// src/components/app-small-box.vue